import { DefaultPipe } from '@/pipes/default.pipe';
import { BinderService } from '@/services/api/binder.service';
import { BinderDeliverablesService } from '@/services/app/binder-deliverables.service';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { CommonModule } from '@angular/common';
import { Component, effect } from '@angular/core';
import { ChipModule } from 'primeng/chip';
import { SkeletonModule } from 'primeng/skeleton';
import { UserAccessService } from 'src/app/services/app/user-access.service';

@Component({
    selector: 'app-design-criteria',
    imports: [SkeletonModule, ChipModule, CommonModule],
    template: `
<div class="card flex flex-col gap-4">
    <div class="text-2xl font-bold">Design Criteria</div>
    <!-- <div class="flex flex-wrap gap-4">
        <div class="flex flex-col grow basis-0 gap-2">
            <label class="text-500 font-medium">Orientation</label>
            {{currentBinderService.currentBinder().Orientation}}
        </div>
        <div class="flex flex-col grow basis-0 gap-2">
            <label class="text-500 font-medium">Jurisdiction</label>
            {{currentBinderService.currentBinder().County}}
        </div>
    </div> -->
    <div class="flex flex-wrap gap-4">
    <div class="flex flex-col grow basis-0 gap-2">
            <label class="text-500 font-medium">Jurisdiction</label>
            {{currentBinderService.currentBinder().County}}
        </div>
        <div class="flex flex-col grow basis-0 gap-2">
            <label class="text-500 font-medium">Seismic</label>
            {{currentBinderService.currentBinder().Seismic}}
        </div>
    </div>
    <div class="flex flex-wrap gap-4">
        <div class="flex flex-col grow basis-0 gap-2">
            <label class="text-500 font-medium">Parcel</label>
            {{currentBinderService.currentBinder().SitePlot}}
        </div>
    </div>
    <!-- <div class="flex flex-wrap gap-4">
        <div class="flex flex-col grow basis-0 gap-2">
            <label class="text-500 font-medium">Deliverables</label>
            <p-chip *ngFor="let deliverable of currentBinderService.currentBinder().BinderDeliverables"
                [label]="deliverable.Deliverables.Name + ' (' + deliverable.Quantity + ')'" class="ml-2"></p-chip>
        </div>
    </div> -->
    <div class="flex flex-wrap gap-4">
        <div class="flex flex-col grow basis-0 gap-2">
            <label class="text-500 font-medium">Windload</label>
            {{currentBinderService.currentBinder().windload}} {{currentBinderService.currentBinder().windType}}
        </div>
        <div class="flex flex-col grow basis-0 gap-2">
            <label class="text-500 font-medium">Snowload</label>
            {{currentBinderService.currentBinder().snowload}} {{currentBinderService.currentBinder().snowType}}
        </div>
    </div>
    <div class="flex flex-wrap gap-4">
        <div class="flex flex-col grow basis-0 gap-2">
            <label class="text-500 font-medium">Exposure</label>
            {{currentBinderService.currentBinder().Exposure}}
        </div>
        <div class="flex flex-col grow basis-0 gap-2">
            <label class="text-500 font-medium">Soil</label>
            {{currentBinderService.currentBinder().SoilPSF}} PSF
        </div>
    </div>
</div>
`
})
export class DesignCriteriaComponent {
  showEditor: boolean = false;

  constructor(private binderDialogService: BinderDialogService,
    public currentBinderService: BinderService,
    public deliverablesModelService: BinderDeliverablesService,
    public userAccessService: UserAccessService
  ) {
    effect(() => {
      this.binderDialogService.dialogMode().type === 'design' ? this.resetDeliverables() : null;
    });

}

resetDeliverables() {
  this.deliverablesModelService.resetData();
}

openCriteriaEditor() {
  this.binderDialogService.toggleDialog('Design Criteria', 'design',true);
}

onUpdate() {
  this.showEditor = false;
}

}
